'use strict';
function alwaysValid() {
  return true;
}

module.exports = {
  alwaysValid: alwaysValid,
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/html-to-react/lib/is-valid-node-definitions.js
// module id = 504
// module chunks = 8